const styles = {
  wrapperForAutocompleteSuggestions: {
    textAlign: 'left',
  },
};

export default styles;
